import throttle from 'lodash/throttle';
import moment from 'moment';

const EXIT_INTENT_COOLDOWN_UNTIL = 'EXIT_INTENT_COOLDOWN_UNTIL';
const MIN_DESKTOP_WIDTH = 992;

type Options = {
  threshold?: number;
  maxDisplays?: number;
  eventThrottle?: number;
  onExitIntent?: () => any,
  cooldown?: number | null,
};

export default function ExitIntent(options: Options = {}) {
  const defaultOptions = {
    threshold: 0,
    maxDisplays: 1,
    eventThrottle: 100,
    onExitIntent: () => {},
    cooldown: 60 * 60 * 24 * 30,
  };
  const exitIntentCooldown = localStorage.getItem(EXIT_INTENT_COOLDOWN_UNTIL);
  if (exitIntentCooldown && moment(exitIntentCooldown).unix() > moment().unix()) return () => null;
  if (window.innerWidth < MIN_DESKTOP_WIDTH) return () => null;

  return (function() {
    const config = { ...defaultOptions, ...options };
    const eventListeners = new Map<string, {eventName: string, callback: (event: any) => any}>();
    let displays = 0;

    const addEvent = (eventName: string, callback: (event: any) => any) => {
      const key = `document:${eventName}`;
      removeEvent(key);
      document.addEventListener(eventName, callback, false);
      eventListeners.set(key, { eventName, callback });
    };

    const removeEvent = (key: string) => {
      const eventListener = eventListeners.get(key);
      if (eventListener) {
        const { eventName, callback } = eventListener;
        document.removeEventListener(eventName, callback);
        eventListeners.delete(key);
      }
    };

    const shouldDisplay = (position: number) => {
      if (position <= config.threshold && displays < config.maxDisplays) {
        displays++;
        return true;
      }
      return false;
    };

    const mouseDidMove = (event: any) => {
      if (shouldDisplay(event.clientY)) {
        config.onExitIntent();
        if (displays >= config.maxDisplays) {
          removeEvents();
          if (config.cooldown) {
            localStorage.setItem(EXIT_INTENT_COOLDOWN_UNTIL, moment().add(config.cooldown, 'seconds').toISOString());
          }
        }
      }
    };

    const removeEvents = () => {
      eventListeners.forEach((value, key) => removeEvent(key));
    };

    addEvent('mousemove', throttle(mouseDidMove, config.eventThrottle));

    return removeEvents;
  })();
}
